import React from 'react';
import DatePicker from '../../../components/datePicker';
import NewPlotTabs from '../../../components/plotTabs/newPlotTabs';
import { DataTableComp } from '../../../components/dataTable';
import { LomavisH2 } from '../../../lomavisSharedUi/atoms/typography/LomavisH2';
import { getAllDates } from '../../../utils/dateUtils';
import { useTranslate } from '@tolgee/react';

interface GrowthTabProps {
  dates: any;
  setDates: (dates: any) => void;
  plotsData: any;
  newConfigsMap: any;
  error: boolean;
  loading: boolean;
  show_data_import_info: boolean;
  locationslug?: string;
}

const GrowthTab: React.FC<GrowthTabProps> = ({
  dates,
  setDates,
  plotsData,
  newConfigsMap,
  error,
  loading,
  show_data_import_info,
  locationslug
}) => {
  const { t } = useTranslate();

  return (
    <div>
      <div className="d-flex flex-column flex-lg-row justify-content-lg-end">
        <DatePicker setDates={setDates} />
      </div>
      <div className="m-5" />
      <div className="m-5" />
      <LomavisH2 title={t('platform_analytics.title.PlotSection')} />
      <div className={'mb-5'} />

      <NewPlotTabs
        labelsLength={getAllDates(dates.startDate, dates.endDate).length}
        sync={show_data_import_info}
        data={plotsData}
        config={newConfigsMap}
        display={true}
        hasError={error}
        isLoading={loading}
      />

      <DataTableComp location={locationslug} />
      <div className="m-2" />
    </div>
  );
};

export default GrowthTab;